function canBuildOWCalendarRequest({ tripDetails = {
    flights: [],
    cabinClass: '',
    tripType: ''
}, displayMonths }) {
    const { flights = [] } = tripDetails;
    if (!displayMonths) return false;
    const { displayedFromMonth, displayedToMonth } = displayMonths;
    return !(!flights?.[0]?.arrivalAirport || !flights?.[0]?.departureAirport || !displayedFromMonth || !displayedToMonth);
}
function canBuildRTCalendarRequest({ tripDetails, displayMonths, departDate }) {
    if (!canBuildOWCalendarRequest({
        tripDetails,
        displayMonths
    })) return false;
    const { flights } = tripDetails;
    const departureDate = departDate || flights[0].departureDate;
    return !!departureDate;
}
export { canBuildOWCalendarRequest, canBuildRTCalendarRequest };
